export default {"src":"/_next/static/image/public/assets/feature-images/en/thesaurus.586ef91fd0c986022f5c2b84c61787ca.svg","height":381,"width":552};